import { memo } from 'react';
import styles from './DateRangeFilter.module.scss';
import type { DateRangeInputProps } from './DateRangeInput';
import DateRangeInput from './DateRangeInput';

const DateRangeFilter = (props: DateRangeInputProps) => {
    return <DateRangeInput {...props} rounded theme={styles.theme} />;
};

export default memo(DateRangeFilter);
